// @flow

import React, { type Node } from 'react';
import {
  usePendingIncomingPayment,
  getOxxoBarcode,
  getSafeDueDate,
  getSafeGatewayVoucherCode,
} from '@tectonics/prs/incoming-payment';
import { getWeekDay } from '@tectonics/prs/week-day';
import {
  RenderButtonArea,
  RenderPaymentInstructions,
} from './oxxo-page-components';
import { EmailVoucherMessage } from '../commons/email-voucher-message';
import { VariableWidthDiv } from '../commons/render-helpers';
import { VoucherText } from '../commons/voucher/voucher-text';
import { DisplayBarcode } from '../commons/display-barcode';
import { VoucherNumberBox } from '../commons/voucher-number-box';
import { OxxoNumber } from '../voucher-page/oxxo-number';
import { Separator } from '../../../atoms';
import { DisplayDueDate } from '../../../organisms/display-due-date';
import { DisplayTotalAmount } from '../../../organisms/display-total-amount';
import {
  PaymentInfoWrapper,
  DashedHr,
} from '../../../organisms/shared-styled-components';
import { RenderPaymentInfoContainer } from '../../../organisms/payment-info-display';

type OxxoPageProps = {|
  paymentTypeCode: string,
|};

export function OxxoPage({ paymentTypeCode }: OxxoPageProps): Node {
  const incomingPayment = usePendingIncomingPayment();
  const oxxoCode = paymentTypeCode === 'oxxopay' ? getSafeGatewayVoucherCode(incomingPayment): getOxxoBarcode(incomingPayment);

  return (
    <>
      <EmailVoucherMessage
        headerMessage="Boleta OXXO generada!"
        textBeforeEmailAddress="Una copia de su número de la boleta fue enviada a"
        textAfterEmailAddress=", sin embargo, ya puedes pagar tu compra con los siguientes datos:"
      />

      <PaymentInfoWrapper>
        <DisplayTotalAmount label="Valor a pagar" redesign={true} location="left"  />
        <DisplayDueDate label="Fecha de Vencimiento" sublabel={`Pagar hasta el ${getWeekDay(getSafeDueDate(incomingPayment), dueDateWeekDay)}`} redesign={true}   />
        <VoucherNumberBox redesign={true}>
          <VoucherText><b>Datos para pago</b></VoucherText>
          <VariableWidthDiv width="70">Dicté el número de referencia o escaneé el código de barras para pagar</VariableWidthDiv>
          <DisplayBarcode countryCode="MX" paymentTypeCode={paymentTypeCode} />
          <OxxoNumber oxxoCode={oxxoCode}/>
        </VoucherNumberBox>
      </PaymentInfoWrapper>

      <Separator direction="vertical" size={3} />

      <RenderButtonArea />

      <RenderPaymentInstructions />

      <VariableWidthDiv width="65">*Recuerda que OXXO cobra una comisión adicional de $15.00</VariableWidthDiv>

      <DashedHr />

      <RenderPaymentInfoContainer
        h1Text="¿Ya conoces la Central de Ayuda EBANX?"
        items={[
          {
            imgSrc: 'https://cdn.ebanx.com/images/vouchers/files-icon.svg',
            subText: 'Si tienes dudas adicionales acerca de tu pago, o tu reembolso visítanos en la Central de Ayuda EBANX:',
            strong:  'ayuda.ebanx.com/hc/es-mx',
          },
        ]}
      />
    </>
  );
}

const dueDateWeekDay = [
  'lunes',
  'lunes',
  'martes',
  'miércoles',
  'jueves',
  'viernes',
  'lunes',
];
